// @flow
import React from "react";
import classNames from "classnames";
import { connect, useSelector } from "react-redux";
import { isMultiplasMedidasSelecionadas } from "../../util";
import { isEmpty, prop, values } from "ramda";
import { Maybe } from "ramda-fantasy";

import { openModal, IconButton } from "@quantum/ui";
import { useI18n } from "@quantum/i18n";

// $FlowFixMe
import { ReactComponent as IconeAdicionar } from "../../assets/icone_adicionar.svg";

import {
  type GeradorMedidasSelecionadas,
  criarSelectorMedidasSelecioandas,
  getAdicionarMedidaDesabilitado,
  getIndiceMedidaEditada,
  getGrupamentoMedidaSelecionado,
  getModoExibicaoMedidaSelecionada,
} from "../../state";

import { getActionCreatorAdicionar } from "../../components/edicaoMedidas/modosExibicao/ModoExibicao";

import type {
  GrupamentoMedida,
  MedidaSelecionada,
  ErrosSelecao,
} from "../../model";
import {
  GRUPAMENTO_MEDIDAS_QUALITATIVAS,
  GRUPAMENTO_MEDIDAS_PERSONALIZADAS,
} from "../../model";
import { criarFuncaoValidacaoSelecaoPeriodo } from "./configuracoes/periodos/SelecaoPeriodo";
import { criarFuncaoValidacaoSelecaoPeriodoIndicadoresFinanceiros } from "./configuracoes/periodos/SelecaoPeriodoIndicadoresFinanceiros";
import { criarFuncaoValidacaoSelecaoMedidas } from "../selecaoMedidas";
import { criarFuncaoValidacaoSelecaoCorrecaoMonetaria } from "./configuracoes/correcaoMonetaria/SelecaoCorrecaoMonetaria";
import { criarFuncaoValidacaoSelecaoDeflacao } from "./configuracoes/deflacao/SelecaoDeflacao";
import { criarFuncaoValidacaoSelecaoNormalizacao } from "./configuracoes/deflacao/SelecaoNormalizacao";
import { modosExibicao } from "./modosExibicao/ModoExibicao";

import "./adicionar-medida.css";

type Props = {
  habilitado: boolean,
  obterMedidasSelecionadas: any => Array<MedidaSelecionada>,
  geradorMedidasSelecionadas: GeradorMedidasSelecionadas,
  grupamentoMedidaSelecionado: GrupamentoMedida,
  dispatch: any,
  validacaoSelecaoPeriodo: any => ErrosSelecao,
  validacaoSelecaoPeriodoIndicadoresFinanceiros: any => ErrosSelecao,
  validacaoSelecaoMedidas: any => ErrosSelecao,
  validacaoModoDeExibicao: any => ErrosSelecao,
  validacaoSelecaoDeflacao: any => ErrosSelecao,
  validacaoSelecaoCorrecaoMonetaria: any => ErrosSelecao,
  validacaoSelecaoNormalizacao: any => ErrosSelecao,
  indiceMedidaEditada: ?number,
  mostrarConfiguracoesAvancadas: boolean,
  mostrarEspacamento?: boolean,
  modoExibicaoSelecionado: Array<string>,
  novaMedida: boolean,
  state: any,
};

function AdicionarMedida({
  obterMedidasSelecionadas,
  geradorMedidasSelecionadas,
  grupamentoMedidaSelecionado,

  dispatch,
  validacaoSelecaoPeriodo,
  validacaoSelecaoPeriodoIndicadoresFinanceiros,
  validacaoSelecaoMedidas,
  validacaoModoDeExibicao,
  validacaoSelecaoDeflacao,
  validacaoSelecaoCorrecaoMonetaria,
  validacaoSelecaoNormalizacao,
  indiceMedidaEditada,
  mostrarConfiguracoesAvancadas,
  mostrarEspacamento = true,
  modoExibicaoSelecionado,
  novaMedida,
  state,
}: Props) {
  const { translate } = useI18n();

  const actionCreatorAdicionar = useSelector(getActionCreatorAdicionar);

  const { loading, failed, mensagem: erroRemoto } = useSelector(
    getAdicionarMedidaDesabilitado
  );

  const erroRemotoTraduzido = erroRemoto ? translate(erroRemoto) : erroRemoto;

  function getErrosSelecao() {
    if (grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_PERSONALIZADAS) {
      return {
        ...validacaoModoDeExibicao(),
        ...(failed ? { erroRemoto } : {}),
      };
    }

    const erros = {
      ...(grupamentoMedidaSelecionado !== GRUPAMENTO_MEDIDAS_QUALITATIVAS
        ? {
            ...validacaoSelecaoPeriodo(),
            ...validacaoSelecaoPeriodoIndicadoresFinanceiros(),
          }
        : {}),
      ...validacaoSelecaoMedidas(),
      ...validacaoSelecaoNormalizacao(),
      ...validacaoSelecaoDeflacao(),
      ...validacaoSelecaoCorrecaoMonetaria(),
      ...validacaoModoDeExibicao(),
      ...(failed ? { erroRemotoTraduzido } : {}),
    };
    return Object.keys(erros).length === 0 ? null : erros;
  }

  function adicionarMedidas() {
    const erros = {
      ...(getErrosSelecao() || {}),
      ...(loading
        ? { erroLoading: translate("configuracaoRelatorio.carregandoDados") }
        : {}),
    };

    if (isEmpty(erros)) {
      isMultiplasMedidasSelecionadas(modoExibicaoSelecionado)
        ? dispatch(actionCreatorAdicionar[0](obterMedidasSelecionadas()))
        : dispatch(
            actionCreatorAdicionar(obterMedidasSelecionadas(), -1, novaMedida)
          );
    } else {
      dispatch(openModal("ModalErro", { erros: values(erros) }));
    }
  }

  return (
    <div
      className={classNames(
        "AdicionarMedida",
        !mostrarConfiguracoesAvancadas &&
          "AdicionarMedida--sem-configuracoes-avancadas",
        !mostrarEspacamento && "AdicionarMedida--sem-espacamento"
      )}
    >
      <IconButton
        icon={<IconeAdicionar />}
        className="AdicionarMedida__botao"
        onClick={adicionarMedidas}
      >
        {typeof indiceMedidaEditada === "number"
          ? novaMedida
            ? translate("configuracaoRelatorio.novaMedida") || "Nova Medida"
            : translate("configuracaoRelatorio.salvarMedida") || "Salvar Medida"
          : isMultiplasMedidasSelecionadas(modoExibicaoSelecionado)
          ? translate("configuracaoRelatorio.adicionarMedidas") ||
            "Adicionar Medidas"
          : translate("configuracaoRelatorio.adicionarMedida") ||
            "Adicionar Medida"}
      </IconButton>
    </div>
  );
}

export default connect((state, ownProps) => ({
  obterMedidasSelecionadas: criarSelectorMedidasSelecioandas(state)(
    ownProps.geradorMedidasSelecionadas
  ),
  validacaoSelecaoPeriodo: criarFuncaoValidacaoSelecaoPeriodo(state),
  validacaoSelecaoPeriodoIndicadoresFinanceiros: criarFuncaoValidacaoSelecaoPeriodoIndicadoresFinanceiros(
    state
  ),
  modoExibicaoSelecionado: getModoExibicaoMedidaSelecionada(state),
  validacaoSelecaoMedidas: criarFuncaoValidacaoSelecaoMedidas(state),
  validacaoModoDeExibicao: Maybe(getModoExibicaoMedidaSelecionada(state))
    .map(modo => modosExibicao[modo])
    .map(prop("funcaoValidacaoAdicionar"))
    .chain(Maybe)
    .map(criarFuncaoValidacao => criarFuncaoValidacao(state))
    .getOrElse(() => ({})),
  validacaoSelecaoDeflacao: criarFuncaoValidacaoSelecaoDeflacao(state),
  validacaoSelecaoCorrecaoMonetaria: criarFuncaoValidacaoSelecaoCorrecaoMonetaria(
    state
  ),
  validacaoSelecaoNormalizacao: criarFuncaoValidacaoSelecaoNormalizacao(state),
  indiceMedidaEditada: getIndiceMedidaEditada(state),
  grupamentoMedidaSelecionado: getGrupamentoMedidaSelecionado(state),
  mostrarConfiguracoesAvancadas: ownProps.mostrarConfiguracoesAvancadas,
  mostrarEspacamento: ownProps.mostrarEspacamento,
  novaMedida: ownProps.novaMedida || false,
  state: state,
}))(AdicionarMedida);
